import { ContentLayout } from '@nohara-dxdev/react-core';
import { ADMIN_PERMISSIONS, OidcProtectedComponent } from '@nohara-dxdev/react-oidc';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router';

import { AdminLayout } from '@/components/layouts';

import NotFoundRoute from '../not-found';

export const ErrorBoundary = () => {
  const { t } = useTranslation();
  return (
    <AdminLayout>
      <ContentLayout title={t('common.errors.somethingWentWrong')}>Error</ContentLayout>
    </AdminLayout>
  );
};

const AdminRoot = () => {
  return (
    <OidcProtectedComponent
      requireAll={ADMIN_PERMISSIONS}
      scope=""
      fallbackElement={<NotFoundRoute />}
    >
      <AdminLayout>
        <Outlet />
      </AdminLayout>
    </OidcProtectedComponent>
  );
};

export default AdminRoot;
